import { render, staticRenderFns } from "./PageHiddenTip.vue?vue&type=template&id=7a7c2be6&scoped=true&"
import script from "./PageHiddenTip.vue?vue&type=script&lang=js&"
export * from "./PageHiddenTip.vue?vue&type=script&lang=js&"
import style0 from "./PageHiddenTip.vue?vue&type=style&index=0&id=7a7c2be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c2be6",
  null
  
)

export default component.exports